import ClassName from "models/classname";
import { forwardRef } from "react";

import styles from "./Container.module.scss";

const Container = forwardRef((props, ref) => {
    const { children, className } = props;
    const containerClassName = new ClassName(styles.container);

    containerClassName.addIf(className, className);

    return (
        <div ref={ref} className={containerClassName.toString()}>
            {children}
        </div>
    );
});

export default Container;
